module.exports = __webpack_public_path__ + "static/media/arrow-down.9a64cc75.svg";